"use client";

import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import { Progress } from "@/components/ui/progress";

export default function Loader() {
  const pathname = usePathname();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const link = target.closest("a");

      if (!link || !link.href || link.target === "_blank") return;

      const nextUrl = new URL(link.href, window.location.origin);
      const currentUrl = new URL(window.location.href);

      const isInternal =
        nextUrl.origin === currentUrl.origin &&
        nextUrl.pathname !== currentUrl.pathname;

      if (!isInternal) return;

      setVisible(true);
      setProgress(10);

      if (intervalRef.current) clearInterval(intervalRef.current);

      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev < 30) return prev + 5;
          if (prev < 60) return prev + 2;
          if (prev < 85) return prev + 1;
          return 90;
        });
      }, 150);
    };

    document.addEventListener("click", handleClick, true);

    return () => {
      document.removeEventListener("click", handleClick, true);
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  useEffect(() => {
    if (!visible) return;

    if (intervalRef.current) clearInterval(intervalRef.current);

    setProgress(100);

    const timeout = setTimeout(() => {
      setVisible(false);
      setProgress(0);
    }, 300);

    return () => clearTimeout(timeout);
  }, [pathname]);

  if (!visible) return null;

  return (
    <div className="pointer-events-none fixed left-0 top-0 z-[9999] h-[4px] w-screen">
      <Progress value={progress} className="h-full w-full" />
    </div>
  );
}